"use client"

import { useEffect, useRef, useState } from "react"

interface TitleTickerProps {
  title: string
  className?: string
}

export function TitleTicker({ title, className = "" }: TitleTickerProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const [animationDuration, setAnimationDuration] = useState(10)

  // Debug: Log when component receives title
  useEffect(() => {
    console.log('[TitleTicker] Received title:', title)
    console.log('[TitleTicker] Component mounted')
  }, [title])

  useEffect(() => {
    if (!containerRef.current || !textRef.current) {
      console.log('[TitleTicker] Refs not ready')
      return
    }

    const containerWidth = containerRef.current.offsetWidth
    const textWidth = textRef.current.scrollWidth

    console.log('[TitleTicker] Dimensions:', { containerWidth, textWidth })

    // Only animate if text is wider than container
    if (textWidth > containerWidth) {
      setShouldAnimate(true)
      // Calculate duration based on text length (slower for longer text)
      const duration = Math.max(10, (textWidth / containerWidth) * 8)
      setAnimationDuration(duration)
      console.log('[TitleTicker] Animation enabled, duration:', duration)
    } else {
      setShouldAnimate(false)
      console.log('[TitleTicker] No animation needed')
    }
  }, [title])

  return (
    <div
      ref={containerRef}
      className={`relative overflow-hidden bg-muted/30 rounded-md px-3 py-2 min-h-[32px] ${className}`}
    >
      <div
        ref={textRef}
        className={`whitespace-nowrap text-sm text-foreground font-medium ${
          shouldAnimate ? "animate-scroll-title" : ""
        }`}
        style={
          shouldAnimate
            ? {
                animationDuration: `${animationDuration}s`,
              }
            : undefined
        }
      >
        {title}
        {shouldAnimate && (
          <>
            {/* Duplicate text for seamless loop */}
            <span className="inline-block ml-8">{title}</span>
          </>
        )}
      </div>
    </div>
  )
}
